import { useEffect, useState } from 'react'

import { GeoLocationDetails } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

interface ReturnType {
   currentLocation: GeoLocationDetails | undefined
}

interface Props {
   onSuccess?: (location: GeoLocationDetails) => void
   onFailure?: () => void
}

export const useCurrentLocation = (props?: Props): ReturnType => {
   const [currentLocation, setCurrentLocation] = useState<
      GeoLocationDetails | undefined
   >()

   useEffect(() => {
      if (navigator.geolocation) {
         navigator.geolocation.getCurrentPosition(
            position => {
               const { latitude, longitude } = position.coords
               const location: GeoLocationDetails = {
                  latitude,
                  longitude
               }
               setCurrentLocation(location)
               props?.onSuccess?.(location)
            },
            props?.onFailure,
            { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
         )
      }
   }, [])

   return {
      currentLocation
   }
}
